import { formatChange, formatTimestamp } from './ChangeFormatter';
import { getAvatarData } from '../../utils/avatarUtils';
import RatingIcon from '../shared/RatingIcon';

function renderChange(c) {
  // Icon changes: render visual icon instead of name text.
  if (c.field === 'icon_assigned' || c.field === 'icon_removed') {
    const who = c.agent || 'Sistema';
    const verb = (!c.old && c.new) ? 'asignó icono'
               : (c.old && !c.new) ? 'quitó icono'
               : 'cambió icono:';
    return (
      <span className="inline-flex items-center gap-1 flex-wrap">
        <span>{who} {verb}</span>
        {c.old && <RatingIcon iconId={c.old} size="sm" />}
        {c.old && c.new && <span className="text-gray-400">→</span>}
        {c.new && <RatingIcon iconId={c.new} size="sm" />}
      </span>
    );
  }
  return <span>{formatChange(c)}</span>;
}

export default function ChangeRow({ group, onContactClick }) {
  const { name, phone, last_change_at, change_count, changes } = group;
  const avatar = getAvatarData(name, phone);

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-3 mb-2">
      <button
        onClick={() => onContactClick?.(phone)}
        className="w-full flex items-center gap-3 hover:bg-gray-50 dark:hover:bg-slate-700/50 rounded p-1 transition text-left"
      >
        <div
          className="w-10 h-10 rounded-full text-white flex items-center justify-center text-sm font-bold flex-shrink-0"
          style={{ background: avatar.gradient }}
        >
          {avatar.initials}
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-semibold text-base text-gray-900 dark:text-gray-100 truncate">{name}</div>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            {phone} · {change_count} {change_count === 1 ? 'cambio' : 'cambios'} · más reciente {formatTimestamp(last_change_at)}
          </div>
        </div>
      </button>
      <ul className="mt-2 ml-13 space-y-1 border-l-2 border-gray-200 dark:border-slate-600 pl-3">
        {changes.map((c, i) => (
          <li key={i} className="text-base text-gray-700 dark:text-gray-300 flex items-start gap-2">
            <span className="text-sm text-gray-400 dark:text-gray-500 font-mono flex-shrink-0">{formatTimestamp(c.at)}</span>
            <div className="flex-1 min-w-0">{renderChange(c)}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
